import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { WelaraMinutesService } from '../../../services/welara-minutes.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import {ColDef, GridApi, GridReadyEvent, RowClassParams, RowStyle} from 'ag-grid-enterprise';
import * as dayjs from 'dayjs';
import * as tz from 'dayjs/plugin/timezone';
import * as utc from 'dayjs/plugin/utc';
import * as duration from 'dayjs/plugin/duration';

dayjs.extend(utc);
dayjs.extend(tz);
dayjs.extend(duration);
import { marked } from 'marked';

@Component({
  selector: 'app-minutes',
  templateUrl: './minutes.component.html',
  styleUrls: ['./minutes.component.css']
})

export class MinutesComponent implements OnInit {
  columnDefs: ColDef[] = [];
  columnDefsList: ColDef[] = [];
  ddSettingsClient: IDropdownSettings = {};
  ddSettingsUser: IDropdownSettings = {};
  ddSettingsLocation: IDropdownSettings = {};
  ddSettingsDivision: IDropdownSettings = {};
  dropdownList: any[] = [];
  editorMode = "add";
  errorMsg = "";
  gridApi!: GridApi<any>;
  minutesGridApi!: GridApi<any>;
  listUsers: any[] = [];
  listClients: any[] = [];
  listLocations: any[] = [];
  listDivisions: any[] = [];
  listMeetings: any[] = [];
  minutesForm: any = {
    existingClient: '',
    newClientName: '',
    meetingDate: '',
    meetingTopic: '',
    meetingLocation: '',
    meetingLocationName: '',
    meetingDivision: '',
    showLocationEntry: false,
    meetingTitle: 'Meeting Title',
    content_materials: '[Document One](https://os.welara.com)',
    show_materials: false,
    content_agenda: 'Agenda Item One\nAgenda Item Two\nAgenda Item Three',
    show_agenda: false,
    content_minutes: 'Minutes 1\nMinutes 2\nMinutes 3\nMinutes 4',
    show_minutes: false,
    content_actionitems: '**Action item:**\n',
    show_actionitems: false,
    content_attendees:'',
    content_absentees: ''
  };
  rowData: any[] = [];
  rowDataInternal: any[] = [];
  rowDataExternal: any[] = [];
  rowDataMinutes: any[] = [];
  rowSelection: any = "single";
  selectedClients: any[] = [];
  selectedItems: any[] = [];
  selectedUsers: any[] = [];
  token = "";
  isContentLoaded = false;
  showModal = "none";
  showMinutesSaved = true;
  showMinutesEditor = true
  authUser = sessionStorage.getItem('wOSAuthUser');
  authAdmin = sessionStorage.getItem('wOSAdmin');
  userID = this.authUser;
  markdownContent = '';
  
  html_materials: SafeHtml = "";
  html_agenda: SafeHtml = "";
  html_minutes: SafeHtml = "";
  html_actionitems: SafeHtml = "";

  constructor(
    private minutesService: WelaraMinutesService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.ddSettingsClient = {
      singleSelection: true,
      idField: 'id',
      textField: 'first_last',
      enableCheckAll: false,
      allowSearchFilter: true,
      closeDropDownOnSelection: true
    };

    this.ddSettingsUser = {
      singleSelection: false,
      idField: 'id',
      textField: 'first_last',
      enableCheckAll: false,
      itemsShowLimit: 3,
      allowSearchFilter: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Deselect All'
    };

    this.ddSettingsLocation = {
      singleSelection: true,
      idField: 'id',
      textField: 'location_label',
      enableCheckAll: false,
      closeDropDownOnSelection: true
    };

    this.ddSettingsDivision = {
      singleSelection: true,
      idField: 'id',
      textField: 'division_name',
      enableCheckAll: false,
      closeDropDownOnSelection: true
    };

    const user: any = sessionStorage.getItem('wOSUser');
    this.token = JSON.parse(user).stsTokenManager.accessToken;
  }

  loadMinutesData(): void {
    this.minutesService.loadUXData(this.token)
      .then(data => {
        this.listUsers = data.users;
        this.listClients = data.clients;
        this.listLocations = data.locations;
        this.listMeetings = data.meetings;
        this.listDivisions = data.divisions;
        this.minutesGridApi.setGridOption('rowData', this.listMeetings);
        setTimeout(() => {
          this.minutesGridApi.sizeColumnsToFit();
          this.onMarkdownChange('materials');
          this.onMarkdownChange('agenda');
          this.onMarkdownChange('actionitems');
          this.onMarkdownChange('minutes');
        })
      })
      .catch(err => console.error('Error loading assets:', err));
  }

  onGridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
    this.buildColumnSpec(this.listUsers);
    this.gridApi.sizeColumnsToFit();
    this.loadMinutesData();
  }

  onMinutesGridReady(params: GridReadyEvent): void {
    this.minutesGridApi = params.api;
    this.buildListSpec(this.listMeetings);
    console.log("minutes grid ready", this.listMeetings)
  }

  togglePreview(params: any): void {
    this.minutesForm['show_' + params] = !this.minutesForm['show_' + params]
  }

  onMarkdownChange(params:any) {
    const html:any = marked.parse(this.minutesForm['content_' + params]);

    switch (params) {
      case 'materials':
        this.html_materials = this.sanitizer.bypassSecurityTrustHtml(html);
        break;
      case 'agenda':
        this.html_agenda = this.sanitizer.bypassSecurityTrustHtml(html);
        break;
      case 'minutes':
        this.html_minutes = this.sanitizer.bypassSecurityTrustHtml(html);
        break;
      case 'actionitems':
        this.html_actionitems = this.sanitizer.bypassSecurityTrustHtml(html);
        break;
      default:
        break;
    }
  }

  buildColumnSpec(table: any): any {
    const tbl = ['first_last', 'company_name', 'title', 'w_email', 'linkedin_link', 'absentee', 'delete'];
    const labels: any[] = ['Name', 'Company', 'Title', 'Contact', 'LinkedIn Link','Absent', ''];
    const alignments: any[] = ['left', 'left', 'left', 'left', 'left','center','center'];
    const widths: any[] = [125, 150, 150, 150, 0, 80,50];
    const hides: any[] = ['linkedin_link','absentee'];
    const expander = 'first_last';

    let i = 1;
    this.columnDefs = tbl.map((col) => {
      let returnedColDef = {};

      const baseColDef = {
        cellClass: (alignments[i - 1] !== 'left') ? ['text-' + alignments[i - 1]] : [],
        field: col,
        headerName: labels[i - 1],
        headerTooltip: labels[i - 1],
        headerClass: 'text-center',
        editable: false,
        sortable: true,
        filter: false,
        resizable: true,
        width: widths[i - 1],
        tooltipField: col,
        suppressHeaderMenuButton: true,
        suppressSizeToFit: (col == expander) ? false : true,
        cellRenderer: this.cellRenderer,
        cellDataType: (col == 'billable') ? 'boolean' : '',
        hide: (hides.includes(col.toLowerCase())) ? true : false

      };

      if (col === 'delete') {
        returnedColDef = {
          ...baseColDef,
          cellRenderer: (params: any) => {
            const div = document.createElement('div');
            if (params.data.id < 0) {
              const del = document.createElement('span');

              del.className = 'pointer';
              del.innerHTML = (!params.data.isBlank) ?
                `<i class="fas fa-fw fa-trash c_bluedk" title="Delete Row ${params.data.id}" id="del_${params.data.id}"></i>` : ``;

              del.addEventListener('click', (e: any) => {
                e.stopPropagation();
                const key = e.srcElement.id.split('_')[1];
                const answer = confirm('Are you sure you want to delete this time entry?');
                if (answer) this.deleteClick(key);
              });
              div.appendChild(del);
            }
            return div;
          },
          cellRendererParams: {},
          field: `id`,
          cellClass: 'text-center',
          pinned: 'right',
          suppressHeaderMenuButton: true,
          suppressHeaderFilterButton: true,
          resizable: false
        };
      } else if (col === 'first_last') {
        returnedColDef = {
          ...baseColDef,
          cellRenderer: (params: any) => {
            const link = document.createElement('span');
            const field = (params.data.linkedin_link == '') ? 'mailto:' + params.data.w_email : params.data.linkedin_link
            link.className = 'pointer';
            link.innerHTML = (!params.data.isBlank) ?
              `<a href="${field}" target="_blank">${params.data.first_last} ` : ``;

            return link;
          },
          cellRendererParams: {},
          field: `id`,
          suppressHeaderMenuButton: true,
          suppressHeaderFilterButton: true,
          resizable: false
        };
      } else if (col === 'absentee') {
        returnedColDef = {
          ...baseColDef,
          cellRenderer: 'agCheckboxCellRenderer',
          cellEditor: 'agCheckboxCellEditor',
     
        }
      } else {
        returnedColDef = baseColDef;
      }

      i++;
      return returnedColDef;
    });
  }

  buildListSpec(table: any): any {
    const tbl = ['dt_stamp', 'client_shortname', 'title', 'delete'];
    const labels: any[] = ['Date', 'Client', 'Meeting Title', ''];
    const alignments: any[] = ['center', 'center', 'left', 'left'];
    const widths: any[] = [125, 125, 0, 50];
    const hides: any[] = [];
    const expander = 'title';

    let i = 1;
    this.columnDefsList = tbl.map((col) => {
      let returnedColDef = {};

      const baseColDef = {
        cellClass: (alignments[i - 1] !== 'left') ? ['text-' + alignments[i - 1]] : [],
        field: col,
        headerName: labels[i - 1],
        headerTooltip: labels[i - 1],
        headerClass: 'text-center',
        editable: false,
        sortable: true,
        filter: false,
        resizable: true,
        width: widths[i - 1],
        tooltipField: col,
        suppressHeaderMenuButton: true,
        suppressSizeToFit: (col == expander) ? false : true,
        cellRenderer: this.cellRenderer,
        cellDataType: (col == 'billable') ? 'boolean' : '',
        hide: (hides.includes(col.toLowerCase())) ? true : false

      };

      if (col === 'delete') {
        returnedColDef = {
          ...baseColDef,
          cellRenderer: (params: any) => {
            const div = document.createElement('div');
            const del = document.createElement('span');

            del.className = 'pointer';
            del.innerHTML = (!params.data.isBlank) ?
              `<i class="fas fa-fw fa-trash c_bluedk" title="Delete Row ${params.data.id}" id="del_${params.data.id}"></i>` : ``;

            del.addEventListener('click', (e: any) => {
              e.stopPropagation();
              const key = e.srcElement.id.split('_')[1];
              const answer = confirm('Are you sure you want to delete this Meeting Minutes file?');
              if (answer) this.deleteClick(key);
            });
            div.appendChild(del);
            return div;
          },
          cellRendererParams: {},
          field: `id`,
          cellClass: 'text-center',
          pinned: 'right',
          suppressHeaderMenuButton: true,
          suppressHeaderFilterButton: true,
          resizable: false
        };
      } else if (col === 'dt_stamp') {
        returnedColDef = {
          ...baseColDef,
          cellRenderer: (params: any) => {
            const welaraDt = document.createElement('span');
            welaraDt.innerHTML = dayjs(params.data.dt_stamp).format('DD/MM/YYYY');
            return welaraDt;
          },
          cellRendererParams: {},
          field: `id`,
          suppressHeaderMenuButton: true,
          suppressHeaderFilterButton: true,
          resizable: false
        };
      } else if (col === 'title') {
        returnedColDef = {
          ...baseColDef,
          cellRenderer: (params: any) => {
            const docLink = document.createElement('span');
            docLink.innerHTML = '<a href="' + params.data.link + '" target="_blank">' + params.data.title + '</a>';
            return docLink;
          },
          cellRendererParams: {},
          field: `id`,
          suppressHeaderMenuButton: true,
          suppressHeaderFilterButton: true,
          resizable: false
        };
      }

      else {
        returnedColDef = baseColDef;
      }

      i++;
      return returnedColDef;
    });
  }

  toggleSaves(): void {
    this.showMinutesSaved = !this.showMinutesSaved;
  }

  toggleEditor(): void {
    this.showMinutesEditor = !this.showMinutesEditor;
  }

  deleteClick(key: any): void {
    this.minutesService.deleteMinutes(key, this.token).then(r => {
      this.loadMinutesData();
    })
  }

  saveMinutes(): void {
    console.log("got to save routine", this.minutesForm.meetingDate)

    if (this.minutesForm.meetingDate == '') {
      this.errorTimed('Please provide a meeting Date', 5000);
      return;
    }

    if (this.minutesForm.meetingTopic == '') {
      this.errorTimed('Please provide a meeting Topic', 5000);
      return;
    }

    if (this.minutesForm.existingClient == '' && this.minutesForm.newClientName == '') {
      this.errorTimed('Please select an existing Client or enter a new Client name', 5000);
      return;
    }

    if (this.minutesForm.meetingLocation.length == 0) {
      this.errorTimed('Please select a meeting Type', 5000);
      return;
    }

    if (this.minutesForm.meetingLocation[0].id == 1 && this.minutesForm.meetingLocationName == '') {
      this.errorTimed('Please provide a meeting Location', 5000);
      return;
    }

    if (this.rowData.length < 1) {
      this.errorTimed('Please enter at least 2 attendees to continue', 5000);
      return;
    }

    if (this.minutesForm.contentAgenda == '') {
      this.errorTimed('Please provide a meeting Agenda', 5000);
      return;
    }

    if (this.minutesForm.contentMinutes == '') {
      this.errorTimed('Please provide meeting Minutes', 5000);
      return;
    }
    if (this.minutesForm.contentActionItems == '') {
      this.errorTimed('Please provide at least one Action Item', 5000);
      return;
    }

    //append attendee data
    this.minutesForm.content_attendees = JSON.stringify(this.rowData)
    //this.errorTimed(JSON.stringify(this.minutesForm),20000)

    this.minutesService.saveMinutes(this.minutesForm, this.token).then(r => {
      this.loadMinutesData();

      //this.minutesForm = {
      //  existingClient: '',
      //  newClientName: '',
      //  meetingDate: '',
      //  meetingTopic: '',
      //  meetingLocation: '',
      //  meetingLocationName: '',
      //  meetingDivision: '',
      //  showLocationEntry: false,
      //  meetingTitle: 'Meeting Title',
      //  content_materials: '[Document One](https://os.welara.com)',
      //  show_materials: false,
      //  content_agenda: 'Agenda Item One\nAgenda Item Two\nAgenda Item Three',
      //  show_agenda: false,
      //  content_minutes: 'Minutes 1\nMinutes 2\nMinutes 3\nMinutes 4',
      //  show_minutes: false,
      //  content_actionitems: '**Action item:**\n',
      //  show_actionitems: false,
      //  content_attendees: '',
      //  content_absentees: ''
      //};
      //this.rowData = [];
      //this.gridApi.setGridOption('rowData', this.rowData);
      this.errorMsg = 'Turn the reset logic back on!'
    })
  }

  onSelectionChanged(event: any) {
    if (event.source != "apiSelectAll") {
      try {
        this.gridApi.setGridOption('loading', true);
        const selectedRows = this.gridApi.getSelectedRows();
        const rowdata: any = selectedRows[0];

        if (rowdata !== undefined) {
          console.log("selected row", rowdata)
        }
        this.gridApi.setGridOption('loading', false);
      } catch (ex) {
        console.log("Error onSelectionChanged", ex)
      }
    }
  }

  cellRenderer(params: any) {
    let template: any = '';
    switch (params.colDef.field) {
      default:
        template = params.getValue();
        break;
    }
    return template;
  }

  getRowStyle = (params: RowClassParams): RowStyle | undefined => {
    return undefined;
  };

  onUserSelect(item: any) {
    this.paintUsers();
    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
    })
  }

  onUserDeselect(item: any) {
    this.paintUsers();
    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
    })
  }

  onClientSelect(item: any) {
    //this.formatTitle()
  }

  onClientDeselect(item: any) {
    //this.formatTitle()
  }

  onDivisionSelect(item: any) {
    this.formatTitle()
  }
  onDivisionDeselect(item: any) {
    this.formatTitle()
  }

  onLocationSelect(item: any) {
    console.log(item, this.minutesForm);
    this.minutesForm.showLocationEntry = (item.id == 1) ? true : false;
  }
  onLocationDeselect(item: any) {
    //this.paintUsers()
    return;
  }

  toggleModal(mode: string): void {
    this.showModal = (mode === 'show') ? 'block' : 'none';
  }

  trackByFn(index: any, record: any) {
    return record.id
  }

  addParty(): void {
    $('#minutesModal .modal-title').html("<i class='fas fa-fw fa-user-plus me-2'></i>Add Party");
    this.toggleModal('show');
  }

  onDateChanged(): void {
    this.minutesForm.meetingDateFormatted = dayjs(this.minutesForm.meetingDate).format('DDMMYYYY');
    this.formatTitle()
  }

  formatTitle(): void {
    const a = ['Welara'];
    if (this.minutesForm.meetingDivision != '') a.push(this.minutesForm.meetingDivision[0].division_name)
    if (this.minutesForm.meetingTopic != '') a.push(this.minutesForm.meetingTopic)
    if (this.minutesForm.existingClient != '') a.push(this.minutesForm.existingClient[0].first_last)
    a.push("Meeting Minutes")
    if (this.minutesForm.meetingDate != '') a.push(this.minutesForm.meetingDateFormatted)

    this.minutesForm.meetingTitle = a.join(' - ')
  }


  paintUsers(): void {
    const html: any[] = [];
    this.rowDataInternal = [];
    for (let i = 0; i < this.selectedUsers.length; i++) {
      const key = this.selectedUsers[i].id;
      const user = this.listUsers.find(o => o.id == key)
      this.rowDataInternal.push(user);
    }
    console.log("rowData", this.rowDataInternal, this.rowDataExternal);
    this.rowData = [...this.rowDataInternal, ...this.rowDataExternal];
    this.gridApi.setGridOption('rowData',this.rowData)
  }

  addExternalCallback(params: any) {
    const row = JSON.parse(params)
    row.first_last = row.f_name + ' ' + row.l_name
    row.last_first = row.l_name + ', ' + row.f_name
    this.rowDataExternal.push(row);
    this.rowData = [...this.rowDataInternal,...this.rowDataExternal]
    this.gridApi.setGridOption('rowData', this.rowData);



  }

  errorTimed(msg: string, timeout: number): void {
    this.errorMsg = msg;
    setTimeout(() => {
      this.errorMsg = ''
    }, timeout)
  }

}
